module.exports = __webpack_public_path__ + "img/arni-dinner.fd258a2b.jpg";